import { motorActionTypes } from 'src/actions/actionTypes'

const initialState = {
  paCoverValues: null,
}

const paCoverAmountReducer = (state = initialState, action = {}) => {
  if (action.type === motorActionTypes.UPDATE_PA_COVER) {
    return { ...state, paCoverValues: action.payload }
  } else {
    return state
  }
}

export default paCoverAmountReducer
